import React from "react";

const Contact = () => {
  return (
    <section
      className="px-6 md:px-12 lg:px-20 py-12 bg-cover bg-center"
      style={{ backgroundImage: "url('/images/fondoNegro.webp')" }}
    >
      <h2 className="text-3xl md:text-6xl font-extrabold text-center mb-8">
        ¡CONTÁCTANOS!
      </h2>

      <div className="grid md:grid-cols-2 gap-10 items-center">
        {/* LEFT SIDE */}
        <div className="space-y-6 text-center md:text-left order-2 md:order-1">
          <p className="leading-relaxed md:text-2xl">
            Nuestro equipo está siempre disponible para resolver tus dudas y
            ayudarte a encontrar los productos ideales que se adapten
            perfectamente a tus necesidades.
          </p>

          {/* Social + Image row */}
          <div className="flex flex-col md:flex-row items-center md:items-start md:space-x-6 space-y-4 md:space-y-0">
            {/* Image first on desktop */}
            <img
              src="/images/handyman.webp"
              alt="Worker"
              className="max-w-[220px] md:max-w-[250px] order-2 md:order-1 mt-12"
            />

            {/* Social links second on desktop */}
            <div className="order-1 md:order-2 space-y-2">
              <p className="font-bold text-center">Síguenos en redes</p>
              <div className="flex flex-col space-y-2 text-base md:text-lg">
                <a
                  href="https://www.facebook.com/omovacarbonfiber"
                  className="flex items-center gap-3 justify-center md:justify-start hover:text-green-600 transition-colors"
                >
                  <img
                    src="/icons/Facebook.webp"
                    alt="Facebook"
                    className="w-4 h-4 md:w-5 md:h-5"
                  />
                  <span className="text-black underline font-semibold">
                    @omovacarbonfiber
                  </span>
                </a>

                <a
                  href="https://www.instagram.com/omovacarbonfiber/"
                  className="flex items-center gap-3 justify-center md:justify-start hover:text-green-600 transition-colors"
                >
                  <img
                    src="/icons/IG.webp"
                    alt="Instagram"
                    className="w-4 h-4 md:w-5 md:h-5"
                  />
                  <span className="text-black underline font-semibold">
                    @omovacarbonfiber
                  </span>
                </a>

                <a
                  href="https://www.tiktok.com/@omovacarbonfiber"
                  className="flex items-center gap-3 justify-center md:justify-start hover:text-green-600 transition-colors"
                >
                  <img
                    src="/icons/Tiktok.webp"
                    alt="Tiktok"
                    className="w-4 h-4 md:w-5 md:h-5"
                  />
                  <span className="text-black underline font-semibold">
                    @omovacarbonfiber
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="bg-gray-800 text-white p-6 rounded-xl order-1 md:order-2">
          <form
            action="https://docs.google.com/forms/d/e/1FAIpQLSd4ZulzPRLJGtoi-WeHisySaZbwcNPfnK9g13Z_O7_DHun8aA/formResponse"
            method="POST"
            target="_blank"
            className="space-y-4"
          >
            <div className="grid grid-cols-2 gap-4">
              <div className="flex flex-col">
                <label className="text-sm font-bold mb-1 text-left">
                  NOMBRE
                </label>
                <input
                  type="text"
                  name="entry.434584348"
                  placeholder="Nombre"
                  className="w-full px-3 py-2 rounded text-black"
                  required
                />
              </div>
              <div className="flex flex-col">
                <label className="text-sm font-bold mb-1 text-left">
                  APELLIDO
                </label>
                <input
                  type="text"
                  name="entry.516677189"
                  placeholder="Apellido"
                  className="w-full px-3 py-2 rounded text-black"
                  required
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="flex flex-col">
                <label className="text-sm font-bold mb-1 text-left">
                  E-MAIL
                </label>
                <input
                  type="email"
                  name="entry.1218949343"
                  placeholder="E-mail"
                  className="w-full px-3 py-2 rounded text-black"
                  required
                />
              </div>
              <div className="flex flex-col">
                <label className="text-sm font-bold mb-1 text-left">
                  TELÉFONO
                </label>
                <input
                  type="tel"
                  name="entry.1331385319"
                  placeholder="Teléfono"
                  className="w-full px-3 py-2 rounded text-black"
                />
              </div>
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-bold mb-1 text-left">
                MENSAJE
              </label>
              <textarea
                name="entry.725986595"
                placeholder="Mensaje"
                className="w-full px-3 py-2 rounded text-black"
                rows="4"
                required
              />
            </div>

            <button
              type="submit"
              className="bg-green-600 hover:bg-green-700 font-bold px-6 py-2 rounded w-full"
            >
              ENVIAR
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
